import { Permission } from 'interfaces/permissionOption';
import { includes, some } from 'lodash';
import { usePermissions } from 'utils/usePermissions';

import { MULTIPLEX_STAIN_ID } from 'interfaces/stainType';
import { useStudyStainTypeIds } from 'utils/queryHooks/stainType/useStudyStainTypes';
import { useEncodedFilters } from 'utils/useEncodedFilters';

export const multiplexPipelineRunPermissions = [
  Permission.RunMultiplexCellSegmentation,
  Permission.ExecuteMultiplexBinaryClassifier,
  Permission.ExecuteMultiplexBlobSegmentation,
  Permission.ExecuteMultiplexTissueSegmentationMask,
  Permission.ExecuteMultiplexNormalization,
  Permission.ExecuteMultiplexHistogram,
  Permission.ExecuteMultiplexPeakDetection,
  Permission.ExecuteMultiplexThreshold,
  Permission.ExecuteMultiplexCellTyping,
] as const;

export const useCanRunMultiplexPipeline = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { hasPermission, isLoading: isLoadingPermissions } = usePermissions();

  const { queryParams } = useEncodedFilters();
  const studyId = queryParams.filters?.studyId;

  const { data: stainTypesInStudy, isLoading: stainTypesInStudyLoading } = useStudyStainTypeIds(studyId, {
    enabled,
  });

  const isMultiplex = includes(stainTypesInStudy, MULTIPLEX_STAIN_ID);

  const canRunAnyMultiplexPipelineStep = some(multiplexPipelineRunPermissions, hasPermission);

  const canRunMultiplexPipeline = isMultiplex && canRunAnyMultiplexPipelineStep;

  return {
    canRunMultiplexPipeline,
    isLoadingPermissions,
    stainTypesInStudyLoading,
  };
};
